import { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import logo from "../../Images/logo1.png";
import styles from "./ProfileDropDown.module.css";

export default function ProfileDropDown({ setShowProfile }) {
  const [loading, setLoading] = useState(false);
  let authData = JSON.parse(localStorage.getItem("authData"));
  const token = localStorage.getItem("token");
  const user = authData.user;
  console.log(user);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    role: "Admin",
  });
  useEffect(() => {
    setFormData({
      name: user.name,
      email: user.email,
      password: "",
      role: user.role,
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (user.role === "Owner") {
      try {
        const res = await fetch(
          `https://prod.toxboxai.com/api/user/editOwnerData/${user.id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(formData),
          }
        );
        const data = await res.json();
        console.log(data);
        if (res.ok) {
          let updatedData = (authData.user = {
            token,
            user: {
              name: data.user.name,
              id: data.user._id,
              role: data.user.role,
              email: data.user.email,
            },
          });
          localStorage.setItem("authData", JSON.stringify(updatedData));
          setTimeout(() => {
            setLoading(false);
          }, 300);
          setShowProfile(false);
        }
      } catch (err) {
        console.error("Update failed", err);
        setTimeout(() => {
          setLoading(false);
        }, 300);
      }
    } else if (user.role === "Participant") {
      try {
        const res = await fetch(
          `https://prod.toxboxai.com/api/user/editParticipantData/${user.id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(formData),
          }
        );
        const data = await res.json();
        console.log(data);
        if (res.ok) {
          let updatedData = (authData.user = {
            token,
            user: {
              name: data.user.name,
              id: data.user._id,
              role: data.user.role,
              email: data.user.email,
            },
          });
          localStorage.setItem("authData", JSON.stringify(updatedData));
          setTimeout(() => {
            setLoading(false);
          }, 300);
          setShowProfile(false);
        }
      } catch (err) {
        setTimeout(() => {
          setLoading(false);
        }, 300);
        console.error("Update failed", err);
      }
    } else if (user.role === "Vendor") {
      try {
        const res = await fetch(
          `https://prod.toxboxai.com/api/user/editVendorData/${user.id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(formData),
          }
        );
        const data = await res.json();
        console.log(data);
        if (res.ok) {
          let updatedData = (authData.user = {
            token,
            user: {
              name: data.user.name,
              id: data.user._id,
              role: data.user.role,
              email: data.user.email,
            },
          });
          localStorage.setItem("authData", JSON.stringify(updatedData));
          setTimeout(() => {
            setLoading(false);
          }, 300);
          setShowProfile(false);
        }
      } catch (err) {
        setTimeout(() => {
          setLoading(false);
        }, 300);
        console.error("Update failed", err);
      }
    }
  };

  return (
    <div className={styles.dropdownContainer}>
      <div className={styles.modalOverlay}>
        <div className={styles.modal}>
          <img className={styles.logoimg} src={logo} alt="Logo" />
          <h2>Edit Profile</h2>

          <form
            utoComplete="off"
            onSubmit={handleProfileSubmit}
            className={styles.formGrid}
          >
            <label>
              Name:
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </label>
            <label>
              Email:
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </label>
            <label>
              Password:
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter new password"
              />
            </label>
            <label>
              Role:
              <input type="text" name="role" value={formData.role} readOnly />
            </label>
            {loading && (
              <div className={styles.loaderComponenet}>
                <ClipLoader
                  color="#4f46e5"
                  size={150}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              </div>
            )}
            <div className={styles.buttonGroup}>
              <button type="submit">Save</button>
              <button
                type="button"
                onClick={() => {
                  setShowProfile(false);
                }}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
